import { FC } from "react";
import { format } from "date-fns";
import { uk } from "date-fns/locale/uk";
import { Divider, Typography } from "theme";
import { ArrowDown } from "theme/icons";

import { Accordion, AccordionDetails, AccordionSummary, Box, CircularProgress, Grid2 } from "@mui/material";
import { styled } from "@mui/material/styles";

import { usePriceHistory } from "../../../../api/hooks/usePriceHistory/usePriceHistory.ts";

const HistoryItem = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5, 0),
  borderBottomWidth: 1,
  borderBottomStyle: "solid",
  borderBottomColor: theme.palette.secondary.contrastText,
  "&:last-child": {
    borderBottom: "none",
  },
}));

const PriceHistoryDisplay: FC = () => {
  const { data, isFetching } = usePriceHistory();

  if (isFetching) {
    return (
      <Grid2 mt={2} container justifyContent="center">
        <CircularProgress color="secondary" size={24} />
      </Grid2>
    );
  }

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <Box my={2.5} maxWidth="300px">
      <Accordion
        sx={{
          boxShadow: "none",
          "&:before": {
            display: "none",
          },
          backgroundColor: "transparent",
        }}
      >
        <AccordionSummary
          expandIcon={<ArrowDown />}
          sx={{
            padding: 0,
            minHeight: "auto",
            cursor: "pointer",
            "&.Mui-expanded": {
              minHeight: "auto",
            },
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
            "& .MuiAccordionSummary-expandIconWrapper": {
              transition: "transform 0.3s",
            },
            "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
              transform: "rotate(180deg)",
            },
            "&:hover": {
              opacity: 0.7,
            },
          }}
        >
          <Box width="100%">
            <Typography variant="h2" textTransform="uppercase" mb={1.5}>
              Історія змін ціни:
            </Typography>
            <Divider />
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: 0 }}>
          <Box mt={2.5}>
        {data.map((item) => {
          const difference = item.newPrice - item.oldPrice;
          const sign = difference > 0 ? "+" : "";

          return (
            <HistoryItem key={item.id}>
              <Grid2 container justifyContent="space-between" alignItems="center" mb={1}>
                <Typography variant="body2" weight="semiBold">
                  {format(new Date(item.changeDate), "dd MMMM yyyy, HH:mm", {
                    locale: uk,
                  })}
                </Typography>
                <Typography variant="body2" weight="semiBold">
                  {sign}{difference} грн
                </Typography>
              </Grid2>

              <Box>
                <Typography variant="body2">
                  Послуга:
                </Typography>
                <Typography variant="body2" weight="regular" mt={0.5}>
                  {item.changeReason}
                </Typography>
              </Box>
            </HistoryItem>
          );
        })}
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default PriceHistoryDisplay;
